// 短信验证码类型
export const SMS_TYPE = {
  LOGIN: 1,
  BIND_PHONE: 2,
}
